const InterstitialAd = () => {
  return (
    <>
      <div className="interAd">
         <div id="TR-9ec0d151-2f24-11f0-8f72-d1e97797931b"></div>
      </div>
    </>
  );
};

export default InterstitialAd;
